export interface StatisticState {
  whatsappStatisticDetail: WhatsappDetailItem[];
  whatsappStatisticDetailFlag?: string;
  whatsappStatisticGroup: WhatsappGroupItem[];
  // whatsappStatisticGroupMessageCount: number;
  whatsappGroupings: {
    whatsappGroup: string[];
    whatsappGroupByOptionally: string[];
  };
}

export interface WhatsappDetailItem {
  id: string;
  create_date: string;
  originator: string;
  recipient: string;
  partner: string;
  service_provider?: string;
  message?: string;
  message_category?: string,
  status: string,
  error_code: number,
}

export class WhatsappDetailItemInfo {
  id: string = '';
  transport_message_id?: string;
  create_date: string = '';
  sent_date?: string;
  delivery_date?: string;
  read_date?: string;
  defer_date?: string;
  expire_date?: string;
  external_id?: string;
  service_provider?: string;
  originator: string = '';
  recipient: string = '';
  parent_message_id?: string;
  parent_message_transport?: string;
  bulk_id?: string;
  partner: string = '';
  partner_user_login?: string;
  status: string = '';
  error_code?: number;
  error_description?: string;
  message_type?: string;
  message?: string;
  message_category?: string;
  image_link?: string;
  priority?: number;
  partner_price?: string;
  provider_price?: string;
  broker_account_login?: string;
  template_id?: string;
  connection_type?: string;
  ext_id1?: string;
  ext_id2?: string;
  ext_id3?: string;
  ext_id4?: string;
  ext_id5?: string;
  custom_data?: object;
}

export class WhatsappDetailFilterParams {
  date_from: string;
  date_to: string;
  originator?: string = undefined;
  recipient?: string = undefined;
  partner?: string = undefined;
  service_provider?: string = undefined;
  status?: string = undefined;
  error_code?: number = undefined;
  message_type?: string = undefined;
  sent_date_from?: string = undefined;
  sent_date_to?: string = undefined;
  deliver_date_from?: string = undefined;
  deliver_date_to?: string = undefined;
  template_id?: number = undefined;
  bulk_id?: string = undefined;
  broker_account_login?: string = undefined;
  partner_user_login?: string = undefined;
  id?: string = undefined;
  transport_message_id?: string = undefined;
  external_id?: string = undefined;
  message_category?: string = undefined;
  ext_id1?: string = undefined;
  ext_id2?: string = undefined;
  ext_id3?: string = undefined;
  ext_id4?: string = undefined;
  ext_id5?: string = undefined;
  page_number: number = 1;
  message_direction: string;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.message_direction = "mt";
  }
}

export interface WhatsappGroupItem {
  date?: string;
  originator?: string;
  service_provider?: string;
  partner?: string;
  template_id?: string;
  bulk_id?: string;
  message_category?: string;
  delivered: number;
  read: number;
  not_delivered: number;
  transmitted: number;
  expired: number;
  failed: number;
  rejected: number;
  deferred: number;
  total: number;
  partner_price: string;
  provider_price: string;
}

export class WhatsappGroupFilterParams {
  date_from: string;
  date_to: string;
  group_by: string;
  originator?: string = undefined;
  service_provider?: string = undefined;
  partner?: string = undefined;
  template_id?: number = undefined;
  bulk_id?: string = undefined;
  message_category?: string = undefined;
  broker_account_login?: number = undefined;
  message_type?: number = undefined;
  message_direction: string;

  constructor(date_from: string, date_to: string, group_by: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.group_by = group_by;
    this.message_direction = "mt";
  }
}
